import React from "react";
// import InfoSection from "./InfoSection.";
import ParentNavBar from "./Navbar/ParenComponent.js";
import Footer from "./Footer/Footer.js";
import "./home.css";
import GradientWrapper from "./GradientWrapper/GradientWrapper.js";
import { filmData } from "./MovieCard/Movies.js";
import FilmCard from "./FilmCard/FilmCard.jsx";

import {
  Card,
  CardContent,
  Typography,
  Button,
  CardMedia,
  Grid,
  Box,
  ListItemText,
  ListItem,
  Divider,
  List,
  Link,
} from "@mui/material";
import { TestimonialsCard } from "./Testimonials.js";
const sections = [
  {
    title: "English Productions",
    content: `Sharron Aubrey is the creative visionary behind feature films L'Inverno, US Film Sugar, Odyssey of An Empress, Soul  and The Shepherdess. Sharron works with high level award winning, Oscar, Golden Globe and Bafta talent, producers and creatives. Originally from Sydney, Australia, Sharron began her career on the stage and in film training at the Royal Academy of Dramatic Arts UK and The National Institute of Dramatic Arts Australia. Sharron is a Producer, Writer, Actor, Founder and Artistic Director of English Productions, where new, experienced and emerging socially conscious filmmakers are dedicated to producing high quality cinema.`,
  },
  // {
  //   title: "Film Philosophy",
  //   content: `Film holds immense relevance and importance today and can be transformative for future generations. By supporting films, you help create powerful works that drive social change. The stories of the Holocaust raise vital questions about humanity and the necessity of remembering such atrocities as part of a moral fabric. Films foster empathy and promote dialogue, raising awareness for recognizing past injustices and building bridges of tolerance and understanding. Through compelling storytelling, film can inspire reflection, empathy, and ultimately, societal progress.`,
  // },
  // {
  //   title: "Motion Picture \"L'Ca' L'Inverno\"",
  //   content: `We believe the role of the film artist is crucial in influencing our views and actions. No other medium has such a direct impact on the consciousness and emotions of the viewer as film. At English Productions, we are passionate in our global society. 'L'inverno' is a compelling narrative that delves deep into the human experience, exploring the intersection of memory, identity, and the universal struggle for meaning and belonging. Through striking visuals and profound storytelling, the film shines a light on the complexities of our shared humanity. 'L'inverno' is not just a movie; it is a mirror that reflects the triumphs and tribulations of our lives. The film industry has the power to shape our understanding of the world, and we are committed to producing works that resonate with audiences on a deeper level. By recognizing the role of the artist in society, we strive to foster a culture that values creativity, diversity, and innovation. 'L'inverno' is currently in the production phase, where we are identifying key producers, a director, production houses, and talent to bring this vision to life. Join us as we embark on this journey of artistic discovery and social impact.`,
  // },
];
const Productions = () => {
  return (
    <>
      <GradientWrapper>
        <ParentNavBar />
        <div
          style={{
            justifyContent: "center",
            // alignItems: "center",
            display: "flex",
          }}
        >
          <div
            style={{
              paddingTop: 150,
              width: 950,
              alignSelf: "start",
              display: "flex",
              flexDirection: "column",
              paddingLeft: 20,
              paddingRight: 20,
            }}
          >
            <p
              className="someTitleBar"
              style={{
                fontSize: "2rem",
                width: "fit-content",
                color: "#696868",
                lineHeight: "34px",
                // fontFamily: "ImperatorSmallCaps-light",
                display: "flex",
                flexDirection: "column",
                margin: 0,
                marginBottom: 30,
                textTransform: "uppercase",
              }}
            >
              Sharron Aubrey & English Productions
              <span
                style={{
                  width: "100%",
                  height: 4,
                  backgroundColor: "#ece3d2",
                  marginTop: 7,
                  zIndex: -2,
                }}
              ></span>
            </p>
            <p
              style={{
                // fontFamily: "Gotham-Light",
                // color: "#696868",
                lineHeight: "27px",
                marginBottom: "1rem",
                marginTop: 0,
                fontSize: 16,
                fontWeight: "normal",
              }}
            >
              {sections[0].content}
            </p>
            {/* <InfoSection data={sections} /> */}
          </div>
        </div>
        <div
          style={{
            justifyContent: "center",
            // alignItems: "center",
            display: "flex",
          }}
        >
          <div
            style={{
              paddingTop: 20,
              width: 950,
              alignSelf: "start",
              display: "flex",
              flexDirection: "column",
              paddingLeft: 20,
              paddingRight: 20,
            }}
          >
            <p
              className="someTitleBar"
              style={{
                fontSize: "2rem",
                width: "fit-content",
                color: "#696868",
                lineHeight: "34px",
                // fontFamily: "ImperatorSmallCaps-light",
                display: "flex",
                flexDirection: "column",
                margin: 0,
                marginBottom: 30,
                textTransform: "uppercase",
              }}
            >
              Global Recognition Award
              <span
                style={{
                  width: "100%",
                  height: 4,
                  backgroundColor: "#ece3d2",
                  marginTop: 7,
                  zIndex: -2,
                }}
              ></span>
            </p>
            <p
              style={{
                // fontFamily: "Gotham-Light",
                // color: "#696868",
                lineHeight: "27px",
                marginBottom: "1rem",
                marginTop: 0,
                fontSize: 16,
                fontWeight: "normal",
              }}
            >
              Film L’inverno ENGLISH PRODUCTIONS & CEO Sharron Aubrey awarded
              for cinematic brilliance and achievements within the film
              industry. Ms Aubreys creative vision and leadership have propelled
              the company ENGLISH PRODUCTIONS to the forefront of storytelling.
              Committed to socially responsible narratives, paired team of Oscar
              winning creatives and artists underscores the prestigious
              accomplishments that define the films journey. Ms Aubrey ascension
              to CEO and producer has infused the company with a fresh female
              led perspective enhancing an already seasoned team of Hollywood
              Producers and master creatives.
            </p>
            <p
              style={{
                // fontFamily: "Gotham-Light",
                // color: "#696868",
                lineHeight: "27px",
                marginBottom: "1rem",
                marginTop: 0,
                fontSize: 16,
                fontWeight: "normal",
              }}
            >
              Given the prestigious nature of a 2024 Global Recognition Award,
              it's imperative to acknowledge L'inverno's unparalleled commitment
              to innovation within the film production landscape. This dynamic
              leadership structure, which innovates and preserves the integrity
              of artistic creation, embodies the transformational qualities that
              the award seeks to honor.
            </p>
            {/* <InfoSection data={sections} /> */}
          </div>
        </div>
        <div
          style={{
            justifyContent: "center",
            // alignItems: "center",
            display: "flex",
          }}
        >
          <div
            style={{
              // paddingTop: 20,
              width: 950,
              alignSelf: "start",
              display: "flex",
              flexDirection: "column",
              paddingLeft: 20,
              paddingRight: 20,
            }}
          >
            {/* <p
              className="someTitleBar"
              style={{
                fontSize: "2rem",
                width: "fit-content",
                color: "#696868",
                lineHeight: "34px",
                // fontFamily: "ImperatorSmallCaps-light",
                display: "flex",
                flexDirection: "column",
                margin: 0,
                marginBottom: 30,
                textTransform: "uppercase",
              }}
            >
Innovative Leadership
<span
                style={{
                  width: "100%",
                  height: 4,
                  backgroundColor: "#ece3d2",
                  marginTop: 7,
                  zIndex: -2,
                }}
              ></span>
            </p> */}
            <p
              style={{
                // fontFamily: "Gotham-Light",
                // color: "#696868",
                lineHeight: "27px",
                marginBottom: "1rem",
                marginTop: 0,
                fontSize: 16,
                fontWeight: "normal",
              }}
            >
              Innovative leadership driving the narrative forward, LInverno
              distinguishes itself through its devotion to unique and compelling
              stories. These tales do not merely entertain; they resonate
              profoundly with audiences, addressing socially essential themes
              and promoting conscious filmmaking practices. Their fresh approach
              to cinematic storytelling reverberates throughout the industry,
              setting a new standard for aspiring and established filmmakers
              alike.
            </p>
            {/* <InfoSection data={sections} /> */}
          </div>
        </div>
        <Divider sx={{ marginY: 3 }} />
        <Typography
          variant="h4"
          component="div"
          sx={{
            marginBottom: 0,
            maxWidth: 950,
            alignSelf: "center",
            justifySelf: "center",
            marginLeft: "auto",
            marginRight: "auto",
            // fontSize: "1.5em",
            // fontWeight: "bold",
            color: "#555",
            // marginLeft:10
            padding: "0px 20px",
            fontFamily: "Montserrat, sans-serif",
            fontSize: "2rem",
            color: "#696868",
            lineHeight: "34px",
          }}
          fontFamily={"Montserrat, sans-serif"}
          id="quotes"
        >
          Quotes
        </Typography>
        <div
          style={{
            paddingLeft: 20,
            paddingRight: 20,
            maxWidth: 950,
            justifySelf: "center",
            alignSelf: "center",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <TestimonialsCard />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <p
            className="someTitleBar"
            style={{
              fontSize: "2rem",
              color: "#696868",
              lineHeight: "34px",
              display: "flex",
              flexDirection: "column",
              margin: 0,
              marginBottom: 0,
              maxWidth: 950,
              width: "100%",
              paddingTop: 20,
              paddingLeft: 20,
            }}
          >
            Films
          </p>
          <div
            style={{
              // paddingLeft:20,
              // paddingRight:20,
              // paddingTop:20,
              maxWidth: 950,
            }}
          >
            {filmData.map((film, index) => (
              <FilmCard key={index} {...film} />
            ))}
          </div>
        </div>
      </GradientWrapper>
      <Footer />
    </>
  );
};

export default Productions;
